export const CLAIM_UPLOAD_INFO =
  'You can upload a range of file types including PDFs, images, videos, documents, zips, and spreadsheets. If your file is in an unsupported format, please convert it to a PDF before uploading. Each file can be up to 30MB in size.';

export const MAX_TENANT_RESPONSE_LENGTH = 5_000;
